// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Abu0q","index":"styles_index__3wdYo"};